import Derawan1 from "./derawan (1).webp";
import Derawan2 from "./derawan (2).webp";

const derawan = [Derawan1, Derawan2];

export default derawan;
